import usePortfolio from "../hooks/PortfolioProvider";
import Dropdown from "../libs/dropdown/Dropdown";
import _ from "lodash";

export interface IAccountSelectProps {
    current:number;
    showAll:boolean;
    onSelect:(account:number) => void;
}
export default function AccountSelect(props:IAccountSelectProps) {
    const {portfolio} = usePortfolio()
    const options = portfolio.accounts.map(account => ({label:account.name,value:account.id}))
    if (props.showAll) options.unshift({value:-1,label:"Accounts"})
    const onChange = (account:number|null) => props.onSelect(account!)
    return <Dropdown options={options} value={props.current} onChange={onChange}/>
}